import { render } from "./DateInput.vue?vue&type=template&id=772f716c&scoped=true"
import script from "./DateInput.vue?vue&type=script&lang=js"
export * from "./DateInput.vue?vue&type=script&lang=js"

import "./DateInput.vue?vue&type=style&index=0&id=772f716c&scoped=true&lang=scss"
/* custom blocks */
import block0 from "./DateInput.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772f716c"]])

export default __exports__